export default from './InfoMessage'


// WEBPACK FOOTER //
// ./src/components/Modules/InfoMessage/index.js